export default __webpack_public_path__ + "static/media/dta-finder.22d521b6.svg";